import chroma from 'chroma-js';

export function invertColor(hex: string | chroma.Color): string {
    const color = chroma(hex);

    return color.get('lab.l') < 75 ? '#FFFFFF' : '#0000000';
}
